export default "__VITE_ASSET__8b014c9c__"